//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    chartTitle: {
      type: String,
      default: null
    },
    chartImg: {
      type: String,
      default: null
    },
    methodList: {
      type: Array,
      default: () => []
    }
  }
}
